import React from 'react';

import type { LoadableType } from '@confluence/loadable';
import { LoadableLazy } from '@confluence/loadable';

import { CommentButtonPlaceholder } from './CommentButtonPlaceholder.tsx';
import type { CreateUIAnalyticsEvent, WithAnalyticsEventsProps } from '@atlaskit/analytics-next';

export const CommentButtonLazy: LoadableType<
	Omit<
		{
			contentId: string;
			createAnalyticsEvent: CreateUIAnalyticsEvent;
			isFabricPage: boolean;
			isDataLoaded?: boolean;
		},
		keyof WithAnalyticsEventsProps
	> &
		React.RefAttributes<any>
> = LoadableLazy({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-CommentButton" */ './CommentButton.tsx'))
			.CommentButton,
	loading: ({ isDataLoaded }) => <CommentButtonPlaceholder isDisabled={!isDataLoaded} />,
});
